import { Link } from 'react-router-dom';
import { CONSOLE_BUILD_ID, WITNESS_ENV } from '../../lib/console-env';

export function RootPage() {
  const envBadgeClass =
    WITNESS_ENV === 'prod'
      ? 'bg-neutral-900 text-neutral-50'
      : 'bg-amber-500 text-amber-950';

  return (
    <main className="mx-auto flex min-h-screen max-w-xl flex-col justify-center gap-8 px-6 py-16">
      <div className="flex items-center gap-3">
        <span
          className={`rounded px-2 py-0.5 text-xs font-bold uppercase tracking-wider ${envBadgeClass}`}
        >
          {WITNESS_ENV}
        </span>
        <h1 className="font-serif text-2xl tracking-tight">Witness console</h1>
      </div>

      <nav className="flex flex-col gap-2 text-sm">
        <Link
          to="/platform"
          className="text-neutral-900 underline hover:no-underline"
        >
          {'Platform → Tenants'}
        </Link>
      </nav>

      <dl className="grid grid-cols-[max-content_1fr] gap-x-6 gap-y-2 text-sm">
        <dt className="text-neutral-500">Env</dt>
        <dd className="font-mono">{WITNESS_ENV}</dd>
        <dt className="text-neutral-500">Build</dt>
        <dd className="font-mono break-all">{CONSOLE_BUILD_ID}</dd>
      </dl>
    </main>
  );
}
